import React from 'react';
import { ThemeConfig, CalendarEvent } from '../types';

interface MiniCalendarProps {
  theme: ThemeConfig;
  events: CalendarEvent[];
}

const MiniCalendar: React.FC<MiniCalendarProps> = ({ theme, events }) => {
  const today = new Date();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();
  
  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
  
  const days = [];
  for (let i = 0; i < firstDayOfMonth; i++) {
    days.push(null);
  }
  for (let i = 1; i <= daysInMonth; i++) {
    days.push(i);
  }
  
  return (
    <div className={`${theme.cardBg} backdrop-blur-sm rounded-2xl p-4 shadow-lg ${theme.shadow} border ${theme.border}`}>
      <h3 className={`font-bold ${theme.text} text-center mb-3`}>
        {today.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
      </h3>
      <div className="grid grid-cols-7 gap-1 text-xs">
        {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((day, i) => (
          <div key={i} className={`text-center font-semibold ${theme.textLight} py-1`}>
            {day}
          </div>
        ))}
        {days.map((day, i) => (
          <div
            key={i}
            className={`text-center py-1 rounded ${
              day === today.getDate()
                ? `${theme.accent} text-white font-bold`
                : day
                ? `${theme.text} hover:${theme.secondary} cursor-pointer`
                : ''
            }`}
          >
            {day || ''}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MiniCalendar;